/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

function checkForDymoPrinter() {
    try {
        if (!this.printer) {
            this.loadPrinterSilent();
            if (!this.printerCheck) {
                return false;
            }
        }
        
        return false
    }
    catch (e) {
        //labelNotify(e, 'error');
    }
}
/**
 * Where this file's messages go.
 *
 * This script is loaded as a plain <script> and has no access to Angular, so
 * it cannot open a Material dialog itself. The app shell registers a handler
 * on window.trakrNotify; everything below calls labelNotify(), which uses it.
 * The native alert stays only as the fallback for the case where the shell has
 * not registered yet — it is never the intended path.
 *
 * @param {string} message
 * @param {string} [kind]  'error' | 'warning' | 'info'
 */
function labelNotify(message, kind) {
    var text = (message && message.message) ? message.message : String(message);

    if (typeof window !== 'undefined' && typeof window.trakrNotify === 'function') {
        try {
            window.trakrNotify(text, kind || 'error');
            return;
        } catch (e) {
            // fall through to the fallback below
        }
    }

    if (typeof console !== 'undefined' && console.warn) {
        console.warn('[label] ' + text);
    }
    window.alert(text);
}

function printSelected() {
    const labelType = localStorage.getItem('labelType');

    /* A label the customer designed themselves. The menus put "custom:<id>"
       in place of the fixed numeric type; everything else below still means
       the shipped template it always meant. */
    if (labelType && labelType.indexOf('custom:') === 0) {
        printDesignedLabel(labelType.substring(7), collectLabelValues(), 1);
        return;
    }

    if (labelType == "0") {
        printDunnageShelfLabel();
    } else if (labelType == "1") {
        printPriceTagLabel();
    } else if (labelType == "2") {
        printProductLabel();
    } else if (labelType == "3") {
        printShelfLabelCode128();
    } else if (labelType == "4") {
        //printShelfLabelPDF417(); //removed
    } else if (labelType == "5") {
        printShelfLabelQR();
    } else if (labelType == "0") {
        printDunnageShelfLabel();
    } else if (labelType == "6") {
        printSerialNumberLabelQr();
    } else if (labelType == "7") {
        printShippingLabelQrOnly();
    } else if (labelType == "8") {
        printShippingLabelBarcodeOnly();
    }
}

function printDunnageShelfLabel() {
    var labelXMLData = loadFileToElement('./assets/scripts/TimMiniLabel.xml');
    var prodSKU = localStorage.getItem('prdBarcode');
    var prodDesc = escapeXml(localStorage.getItem('prdNameEn'));
    var prodID = localStorage.getItem('prdID');
    var storageStructureID = localStorage.getItem('storageStructureID');
    var storagePrint = localStorage.getItem('storagePrint');
    if(storagePrint=="true"){
        prodID = 0;
    }
    var qrcode = storageStructureID+"|" + prodID;

    labelXMLData = labelXMLData.replace("***ProdBarcodePlaceholder***", qrcode);
    //labelXMLData = labelXMLData.replace("***ProdCodePlaceholder***", prodCode);
    labelXMLData = labelXMLData.replace("***ProdDesPlaceHolder***", prodDesc);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    } catch (e) {
        labelNotify(e, 'error');
    }
}


function printShelfLabelPDF417() {
    var labelXMLData = loadFileToElement('../../assets/dymo/ShelveLabelPDF417.xml');
    var prodCode = localStorage.getItem('prdCode');
    var prodSKU = localStorage.getItem('prdBarcode');
    var prodDesc = escapeXml(localStorage.getItem('prdNameEn'));
    var prodID = localStorage.getItem('prdID');
    var storageStructureID = localStorage.getItem('storageStructureID');
    var storagePrint = localStorage.getItem('storagePrint');
    if(storagePrint=="true"){
        prodID = 0;
    }
    var qrcode = storageStructureID+"|" + prodID;

    labelXMLData = labelXMLData.replace("***ProdBarcodePlaceholder***", qrcode);
    labelXMLData = labelXMLData.replace("***ProdCodePlaceholder***", prodCode);
    labelXMLData = labelXMLData.replace("***ProdDesPlaceHolder***", prodDesc);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    } catch (e) {
        labelNotify(e, 'error');
    }
}

function printShelfLabelQR() {
    var labelXMLData = loadFileToElement('assets/dymo/ShelveLabelQR.xml');
    var prodCode = localStorage.getItem('prdCode')
    var prodSKU = localStorage.getItem('prdBarcode')
    var prodDesc = escapeXml(localStorage.getItem('prdNameEn'));
    var prodID = localStorage.getItem('prdID');
    var storageStructureID = localStorage.getItem('storageStructureID');
    var storagePrint = localStorage.getItem('storagePrint');
    if(storagePrint=="true"){
        prodID = 0;
    }

    var qrcode = storageStructureID+"|" + prodID;

    labelXMLData = applyQrImage(labelXMLData, qrcode);
    labelXMLData = labelXMLData.replace("***ProdBarcodePlaceholder***", qrcode);
    labelXMLData = labelXMLData.replace("***ProdCodePlaceholder***", prodCode);
    labelXMLData = labelXMLData.replace("***ProdDesPlaceHolder***", prodDesc);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    } catch (e) {
        labelNotify(e, 'error');
    }
}

function printSerialNumberLabelQr() {
    var labelXMLData = loadFileToElement('assets/dymo/SerialNumberLabelQR.xml');
    var prodCode = localStorage.getItem('prdCode')
    var prodSerialNumber = localStorage.getItem('serialNumber')
    var prodDesc = escapeXml(localStorage.getItem('prdNameEn'));
    var prodID = localStorage.getItem('prdID');
    var storageStructureID = localStorage.getItem('storageStructureID');

    var qrcode = prodSerialNumber;

    labelXMLData = labelXMLData.replace("***prodSerialNumberQrPlaceholder***", qrcode);
    labelXMLData = labelXMLData.replace("***prodSerialNumberPlaceholder***", 'S/N   : ' + prodSerialNumber);
    labelXMLData = labelXMLData.replace("***ProdCodePlaceholder***", 'SKU : ' + prodCode);
    labelXMLData = labelXMLData.replace("***ProdDescPlaceHolder***", prodDesc);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    } catch (e) {
        labelNotify(e, 'error');
    }
}

function printShelfLabelCode128() {
    var labelXMLData = loadFileToElement('../../assets/dymo/ShelveLabelCode128.xml');
    var prodCode = localStorage.getItem('prdCode');
    var prodSKU = localStorage.getItem('prdBarcode');
    var prodDesc = escapeXml(localStorage.getItem('prdNameEn'));
    var prodID = localStorage.getItem('prdID');
    var storageStructureID = localStorage.getItem('storageStructureID');
    var storagePrint = localStorage.getItem('storagePrint');
    if(storagePrint=="true"){
        prodID = 0;
    }
    var qrcode = storageStructureID+"|" + prodID;

    labelXMLData = labelXMLData.replace("***ProdBarcodePlaceholder***", qrcode);
    labelXMLData = labelXMLData.replace("***ProdCodePlaceholder***", prodCode);
    labelXMLData = labelXMLData.replace("***ProdDesPlaceHolder***", prodDesc);
    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    } catch (e) {
        labelNotify(e, 'error');
    }
}

function printPriceTagLabel() {

    var labelXMLData = loadFileToElement('../../assets/dymo/TenSpotPDF417.xml');

    var prodRetail = localStorage.getItem('prdRetail');
    prodRetail = '$' + prodRetail;

    var prodSKU = localStorage.getItem('prdBarcode');
    var prodDesc = escapeXml(localStorage.getItem('prdNameEn'));
    var prodID = localStorage.getItem('prdID');
    var storageStructureID = localStorage.getItem('storageStructureID');
    var storagePrint = localStorage.getItem('storagePrint');
    if(storagePrint=="true"){
        prodID = 0;
    }
    var qrcode = storageStructureID+"|" + prodID;
    var descLength = prodDesc.length;
    var prodVolume = '';

    if(localStorage.getItem('prdCasePack')){
        prodVolume = localStorage.getItem('prdCasePack');
    }

    var volumeLength = prodVolume.length;

    var availableLength = 26 - volumeLength;
    prodDesc = prodDesc + '... (' + prodVolume + ')';
    // if (descLength > availableLength) {
    //     if (volumeLength == 0) {
    //         availableLength = availableLength - 3;
    //         var tmpDesc = prodDesc.substr(0, availableLength);
    //         prodDesc = tmpDesc + '...';
    //     } else {
    //         availableLength = availableLength - 6;
    //         var tmpDesc = prodDesc.substr(0, availableLength);
    //         prodDesc = tmpDesc + '... (' + prodVolume + ')';
    //     }

    // } else {
    //     prodDesc = prodDesc + ' (' + prodVolume + ')';
    // }

    labelXMLData = labelXMLData.replace("***ProdBarcodePlaceholder***", qrcode);
    labelXMLData = labelXMLData.replace("***ProdPricePlaceholder***", prodRetail);
    labelXMLData = labelXMLData.replace("***ProdDesPlaceHolder***", prodDesc);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    }
    catch (e) {
        labelNotify(e, 'error');
    }

}

function printProductLabel() {
    var labelXMLData = loadFileToElement('../../assets/dymo/ProductLabel.xml');
    var prodCode = getPrintableValue('prdCode');
    var prodDesc = escapeXml(getPrintableValue('prdNameEn'));
    var prodID = getPrintableValue('prdID');
    var storageStructureID = getPrintableValue('storageStructureID');

    if (getPrintableValue('storagePrint') == "true") {
        prodID = 0;
    }

    /* The bin half of the scan payload. Printing from the product list there
       is no bin in play, and the missing value used to reach the barcode as
       the text "null" — the handheld then failed to resolve a code that looked
       perfectly fine on the label. 0 is what the rest of the app sends when
       printing away from a storage location. */
    if (storageStructureID === '') {
        storageStructureID = 0;
    }

    var qrcode = storageStructureID + "|" + prodID;

    /* A product with no default counting method has no retail price, and the
       label used to print the literal "$undefined" in the price corner. */
    var prodRetail = getPrintableValue('prdRetail');
    prodRetail = prodRetail === '' ? '' : '$' + prodRetail;

    var prodVolume = getPrintableValue('prdCasePack');
    if (prodVolume === '') {
        prodVolume = " ";
    }

    labelXMLData = labelXMLData.replace("***ProdBarcodePlaceholder***", qrcode);
    labelXMLData = labelXMLData.replace("***ProdCodePlaceholder***", prodCode);
    labelXMLData = labelXMLData.replace("***ProdDesPlaceHolder***", prodDesc);
    labelXMLData = labelXMLData.replace("***ProdPricePlaceholder***", prodRetail);
    labelXMLData = labelXMLData.replace("***ProdUomPlaceholder***", prodVolume);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;

        // create label from XML file
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);

        // print it
        stampi.print(printer);

    }
    catch (e) {
        labelNotify(e, 'error');
    }

}


function getShelveLabel() {
    var labelXMLRendering = '';
}

function loadFileToElement(filename) {
    var xmlHTTP = new XMLHttpRequest();
    try {
        xmlHTTP.open("GET", filename, false);
        xmlHTTP.send(null);
    }
    catch (e) {
        labelNotify('Unable to load the requested file.', 'error');
        return;
    }

    return xmlHTTP.responseText;
}

/* QR as an image.
   DYMO does not scale a QR barcode object to its bounds — the module size is
   fixed by <Size> and these payloads are short, so the code prints much smaller
   than the space reserved for it. The backend renders the same payload as a PNG
   (with the quiet zone readers require) and it goes in as an ImageObject, which
   does fill its bounds. On any failure the caller keeps the original barcode
   object, so a label still prints. */
function getLabelApiBaseUrl() {
    var stored = localStorage.getItem('apiUrl');
    if (stored) {
        return stored.replace(/\/+$/, '');
    }
    // Same-origin fallback for the deployed app, where the API sits under /api.
    return window.location.origin + '/api';
}

function loadQrImageBase64(data) {
    try {
        var url = getLabelApiBaseUrl() + '/image-upload/label-qr?data=' + encodeURIComponent(data);
        var request = new XMLHttpRequest();
        // Synchronous on purpose: the print helpers are synchronous and are
        // called straight from a click handler.
        request.open('GET', url, false);
        var token = localStorage.getItem('token');
        if (token) {
            request.setRequestHeader('token', token);
        }
        request.send(null);
        if (request.status !== 200) {
            return '';
        }
        var parsed = JSON.parse(request.responseText);
        return parsed && parsed.base64 ? parsed.base64 : '';
    }
    catch (e) {
        return '';
    }
}

/* Swaps in the PNG and removes the barcode object, or removes the image object
   and leaves the barcode alone when there is no PNG. Exactly one of the two
   blocks survives — leaving both would print the code twice. */
function applyQrImage(labelXMLData, qrData) {
    var base64 = loadQrImageBase64(qrData);
    if (base64 === '') {
        return labelXMLData.replace(/<!--QRIMAGE_START-->[\s\S]*?<!--QRIMAGE_END-->/, '');
    }
    labelXMLData = labelXMLData.replace(/<!--QRBARCODE_START-->[\s\S]*?<!--QRBARCODE_END-->/, '');
    return replacePlaceholder(labelXMLData, "***ProdQrImagePlaceholder***", base64);
}

/* Designed labels.
   A template built in the label designer is not a file on disk: the server
   compiles it, with the values already substituted, into the same DieCutLabel
   XML the fixed templates use. So printing one is the existing path with the
   document fetched instead of loaded and string-replaced.

   Values are passed as an object rather than through the dozen localStorage
   keys the fixed templates rely on, because a designed label can carry any
   field in the catalogue and that list is no longer fixed. */
/** Templates whose warnings the operator has already been shown. */
var warnedTemplates = {};

function printDesignedLabel(templateId, values, copies) {
    if (!templateId) {
        return false;
    }

    var prepared = loadDesignedLabelXml(templateId, values || {});
    var xml = prepared.xml;
    if (!xml) {
        labelNotify(prepared.reason || 'This label could not be prepared. Please try again.', 'error');
        return false;
    }

    /* Every remaining warning means something the customer put on the label
       will not appear on the paper. Shown before printing, while a stack of
       labels can still be saved, rather than left in a console nobody opens.

       Once per template per session: the warnings come from the stored layout,
       so they are identical on every copy, and an operator running off fifty
       shelf labels should not have to dismiss the same notice fifty times. */
    if (prepared.warnings.length && !warnedTemplates[templateId]) {
        warnedTemplates[templateId] = true;
        labelNotify('This label will print without part of its design:\n\n'
            + prepared.warnings.join('\n'), 'warning');
    }

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer) {
                throw "No DYMO printers are installed. Install DYMO printers.";
            }
        }

        var printer = this.printer.modelName;
        var label = dymo.label.framework.openLabelXml(xml);
        var count = copies && copies > 1 ? copies : 1;

        for (var i = 0; i < count; i++) {
            label.print(printer);
        }
        return true;
    } catch (e) {
        labelNotify(e, 'error');
        return false;
    }
}

/**
 * The values a designed label can show, keyed as the server's field catalogue
 * keys them.
 *
 * Read from the same localStorage the fixed printers read, so a designed label
 * prints the same data as the built-in one it was copied from. A key nothing
 * has written comes back empty and the server drops the line rather than
 * printing the word "null".
 */
function collectLabelValues() {
    var prodID = getPrintableValue('prdID');
    if (getPrintableValue('storagePrint') == 'true') {
        // A shelf label describes the bin, not whatever product is in it.
        prodID = '0';
    }

    var assetNumber = getPrintableValue('prdAssetsNumber') || getPrintableValue('assetNumber');

    return {
        'product.name': getPrintableValue('prdNameEn') || getPrintableValue('assetProductName'),
        'product.sku': getPrintableValue('prdCode'),
        'product.barcode': getPrintableValue('prdBarcode'),
        'product.price': getPrintableValue('prdRetail'),
        'product.casePack': getPrintableValue('prdCasePack'),
        'product.customField1': getPrintableValue('prdCustomField1'),
        'product.customField2': getPrintableValue('prdCustomField2'),
        'product.assetNumber': assetNumber,
        'product.typeLabel': getPrintableValue('prdIsAsset') == '1' ? 'Type: Asset' : 'Type: Product',
        'serial.number': getPrintableValue('serialNumber'),
        'storage.path': getPrintableValue('storagePath'),
        'location.logo': getPrintableValue('locLogoBase64'),
        'system.scanPayload': getPrintableValue('storageStructureID') + '|' + prodID
    };
}

/** @return {{xml: string, warnings: string[]}} */
function loadDesignedLabelXml(templateId, values) {
    try {
        var url = getLabelApiBaseUrl() + '/label-templates/' + encodeURIComponent(templateId) + '/render';
        var request = new XMLHttpRequest();
        // Synchronous to match the print helpers around it, which are called
        // straight from a click handler.
        request.open('POST', url, false);
        request.setRequestHeader('Content-Type', 'application/json');
        var token = localStorage.getItem('token');
        if (token) {
            request.setRequestHeader('token', token);
        }
        request.send(JSON.stringify({ data: values }));

        if (request.status === 401 || request.status === 403) {
            return { xml: '', warnings: [], reason: 'Your session has expired. Please sign in again.' };
        }
        if (request.status !== 200) {
            return { xml: '', warnings: [] };
        }

        var parsed = JSON.parse(request.responseText);
        return {
            xml: parsed && parsed.labelXml ? parsed.labelXml : '',
            warnings: (parsed && parsed.warnings) || []
        };
    } catch (e) {
        return { xml: '', warnings: [] };
    }
}

function loadPrinter() {
    var printers = dymo.label.framework.getLabelWriterPrinters();
    if (printers.length == 0) {
        return false;
    }
    // assuming there is only one printer
    this.printer = printers[0];
    return true;
}

function loadPrinterSilent() {
    var printers = dymo.label.framework.getLabelWriterPrinters();
    if (printers.length == 0) {
        //alert("No DYMO printers are installed. Install DYMO printers.");
        return;
    }
    // assuming there is only one printer
    this.printerCheck = printers[0];
}

function escapeXml(unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

function replacePlaceholder(labelXMLData, placeholder, value) {
    // Replace via a function so that "$&", "$`", "$'" or "$$" inside product
    // data are inserted literally instead of being read as replace patterns
    return labelXMLData.replace(placeholder, function () { return value; });
}

function getPrintableValue(key) {
    var value = localStorage.getItem(key);
    if (value == null || value == 'null' || value == 'undefined') {
        return '';
    }
    return value;
}

function applyShippingLabelLogo(labelXMLData) {
    var logo = getPrintableValue('locLogoBase64');
    if (logo == '') {
        // No logo on file - drop the image object entirely, an empty one breaks the label
        return labelXMLData.replace(/<!--LOGO_START-->[\s\S]*?<!--LOGO_END-->/, '');
    }
    // Strip the data URI prefix, DYMO expects raw base64
    logo = logo.replace(/^data:image\/[a-z+]+;base64,/i, '');
    return replacePlaceholder(labelXMLData, "***LogoPlaceholder***", logo);
}

function getShippingLabelPrice() {
    var price = getPrintableValue('prdRetail');
    if (price == '') {
        return '';
    }
    // Group thousands only for a plain number; anything already formatted or
    // otherwise unexpected is printed exactly as stored rather than mangled
    if (/^-?\d+(\.\d+)?$/.test(price)) {
        price = parseFloat(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return 'Price: $' + escapeXml(price);
}

function getShippingLabelCategory() {
    var isAsset = getPrintableValue('prdIsAsset');
    return (isAsset == '1' || isAsset == 'true') ? 'Type: Asset' : 'Type: Product';
}

function printShippingLabelQrOnly() {
    var labelXMLData = loadFileToElement('assets/dymo/ShippingLabelQROnly.xml');
    var prodCode = getPrintableValue('prdCode');
    var prodDesc = escapeXml(getPrintableValue('prdNameEn'));
    var assetNumber = getPrintableValue('prdAssetsNumber');
    var prodID = getPrintableValue('prdID');
    var storageStructureID = getPrintableValue('storageStructureID');

    // QR Code - storageStructureID|prdID format (same as other labels, for mobile compatibility)
    var qrcode = storageStructureID + "|" + prodID;

    labelXMLData = applyShippingLabelLogo(labelXMLData);
    labelXMLData = applyQrImage(labelXMLData, qrcode);
    labelXMLData = replacePlaceholder(labelXMLData, "***ProdQrCodePlaceholder***", qrcode);
    labelXMLData = replacePlaceholder(labelXMLData, "***ProductNamePlaceholder***", prodDesc);
    labelXMLData = replacePlaceholder(labelXMLData, "***ProdCodePlaceholder***", 'SKU: ' + escapeXml(prodCode));
    labelXMLData = replacePlaceholder(labelXMLData, "***PricePlaceholder***", getShippingLabelPrice());
    labelXMLData = replacePlaceholder(labelXMLData, "***AssetNumberPlaceholder***", assetNumber != '' ? ('Assets: ' + escapeXml(assetNumber)) : '');
    labelXMLData = replacePlaceholder(labelXMLData, "***CategoryPlaceholder***", getShippingLabelCategory());

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);
        stampi.print(printer);
    } catch (e) {
        labelNotify(e, 'error');
    }
}

function printShippingLabelBarcodeOnly() {
    var labelXMLData = loadFileToElement('assets/dymo/ShippingLabelBarcodeOnly.xml');
    var prodCode = getPrintableValue('prdCode');
    var prodDesc = escapeXml(getPrintableValue('prdNameEn'));
    var prodBarcode = getPrintableValue('prdBarcode');

    // Fall back to the SKU when the product has no barcode of its own
    var barcodeValue = prodBarcode != '' ? prodBarcode : prodCode;

    labelXMLData = applyShippingLabelLogo(labelXMLData);
    labelXMLData = replacePlaceholder(labelXMLData, "***ProdBarcodePlaceholder***", escapeXml(barcodeValue));
    labelXMLData = replacePlaceholder(labelXMLData, "***ProductNamePlaceholder***", prodDesc);
    labelXMLData = replacePlaceholder(labelXMLData, "***ProdCodePlaceholder***", 'SKU: ' + escapeXml(prodCode));
    labelXMLData = replacePlaceholder(labelXMLData, "***PricePlaceholder***", getShippingLabelPrice());
    labelXMLData = replacePlaceholder(labelXMLData, "***CategoryPlaceholder***", getShippingLabelCategory());

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);
        stampi.print(printer);
    } catch (e) {
        labelNotify(e, 'error');
    }
}

function printAssetLabel() {
    var labelXMLData = loadFileToElement('assets/dymo/AssetLabel.xml');
    var assetNumber = localStorage.getItem('assetNumber');
    var productName = escapeXml(localStorage.getItem('assetProductName'));
    var prdID = localStorage.getItem('assetPrdID');
    var storageStructureID = localStorage.getItem('assetStorageStructureID');

    // QR Code - storageStructureID|prdID format (same as other labels, for mobile compatibility)
    var qrcode = storageStructureID + "|" + prdID;
    labelXMLData = applyQrImage(labelXMLData, qrcode);
    labelXMLData = labelXMLData.replace("***AssetNumberQRPlaceholder***", qrcode);
    // Text display - with prefix
    labelXMLData = labelXMLData.replace("***AssetNumberTextPlaceholder***", "Assets : " + assetNumber);
    labelXMLData = labelXMLData.replace("***ProductNamePlaceholder***", productName);

    try {
        if (!this.printer) {
            this.loadPrinter();
            if (!this.printer)
                throw "No DYMO printers are installed. Install DYMO printers.";
        }
        var printer = this.printer.modelName;
        var stampi = dymo.label.framework.openLabelXml(labelXMLData);
        stampi.print(printer);
    } catch (e) {
        labelNotify(e, 'error');
    }
}
